import { connect } from 'react-redux';
import { VENUE_SERVICE_TYPES } from 'constants/logic';
import { providesService, isVenueDashboardSubtypeFoodAndBeverage } from 'helpers/ia-logic';
import { selectActiveVenue } from 'selectors/general';
import ClassesRatingsSummary from './ClassesRatingsSummary';
import { updateClass } from '../Ratings.saga';
import { selectClassesRatings, selectClassesRatingsIsLoading } from '../Ratings.selectors';

const mapStateToProps = state => {
  const { serviceTypes } = selectActiveVenue(state);
  const isVenueFoodAndBeverage = isVenueDashboardSubtypeFoodAndBeverage(selectActiveVenue(state));

  return {
    classesRatings: selectClassesRatings(state),
    isLoading: selectClassesRatingsIsLoading(state),
    offersAppointments: providesService({ serviceTypes }, VENUE_SERVICE_TYPES.APPOINTMENT),
    offersClasses: providesService({ serviceTypes }, VENUE_SERVICE_TYPES.CLASS),
    isVenueFoodAndBeverage,
  };
};

const mapDispatchToProps = { updateClass };

export default connect(mapStateToProps, mapDispatchToProps)(ClassesRatingsSummary);
